<div class="wm-form" *ngIf="liveWidgetSettingsService.activeTab.type === 'fields'"
     [ngClass]='{"disabled" : !liveWidgetSettingsService.selectedComponent.field.pcDisplay &&  !liveWidgetSettingsService.selectedComponent.field.mobileDisplay && !liveWidgetSettingsService.selectedComponent.field.isGroup}'>
  <div class="dialog-form-section">
    <!--Width-->
    <div class="form-group app-composite-widget clearfix"  [hidden]="liveWidgetSettingsService.selectedComponent.field.isGroup">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDTH}}</label>
      <input class="form-control app-textbox" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widthValue"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_COLUMN_WIDTH}}" data-identifier="property-width" />
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.MESSAGE_HELP_PROPERTY_WIDTH}}" class="wms wms-help"></i>
    </div>
    <!--width unit-->
    <div class="form-group app-composite-widget clearfix" [hidden]="liveWidgetSettingsService.selectedComponent.field.isGroup">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_WIDTH_UNIT}}</label>
      <select class="form-control app-select" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.widthUnit" data-identifier="property-widthunit">
        <option *ngFor="let option of liveWidgetSettingsService.unitOptions">{{option}}</option>
      </select>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_WIDTH_UNIT}}" class="wms wms-help"></i>
    </div>
    <!--Text-alignment-->
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_TEXT_ALIGNMENT}}</label>
      <select class="form-control app-select" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.textAlignment" data-identifier="property-textalignment">
        <option *ngFor="let option of liveWidgetSettingsService.textAlignOptions">{{option}}</option>
      </select>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_TEXT_ALIGNMENT}}" class="wms wms-help"></i>
    </div>
    <!--Background color-->
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_BACKGROUND_COLOR}}</label>
      <div class="form-control colorpicker-wrapper" [(colorPicker)]="liveWidgetSettingsService.selectedComponent.field.backgroundColor"
           [cpPosition]="'bottom'"
           [cpPositionOffset]="'12%'"
           [cpPositionRelativeToArrow]="true"
           [cpOutputFormat]="'hex'"
           [cpAlphaChannel]="'disabled'"
           [cpDisableInput]="true"
           [cpWidth]="'auto'"
           [cpHeight]="'auto'"
           (colorPickerChange)="onChange($event)">
          <input placeholder="{{locale.PLACEHOLDER_DESIGNER_COLUMN_BACKGROUND}}" class="form-control app-textbox colorpicker-field" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.backgroundColor" data-identifier="property-background">
          <span class="colorpicker-container input-group-addon">
            <i class="colored-box" [style]="{'backgroundColor':liveWidgetSettingsService.selectedComponent.field.backgroundColor}" [colorIcon]="liveWidgetSettingsService.selectedComponent.field.backgroundColor">&nbsp;</i>
          </span>
      </div>

      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_BACKGROUND_COLOR}}" class="wms wms-help"></i>
    </div>
    <!--Class-->
    <div class="form-group app-composite-widget clearfix">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_CLASS}}</label>
      <input class="form-control app-textbox" [(ngModel)]="liveWidgetSettingsService.selectedComponent.field.class"
             placeholder="{{locale.PLACEHOLDER_DESIGNER_COLUMN_CLASS}}" data-identifier="property-class"/>
      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_CLASS}}" class="wms wms-help"></i>
    </div>
    <!--Conditional Column Classes-->
    <div class="form-group app-composite-widget clearfix" [hidden]="liveWidgetSettingsService.selectedComponent.field.isGroup">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_WIDGET_DESIGNER_CONDITIONAL_CLASS}}</label>
      <div class="conditional-classes-container">
        <div *ngFor="let cls of liveWidgetSettingsService.selectedComponent.field.ngClasses; let index = index;let isFirst = first; let isLast = last">
          <input type="text" [(ngModel)]="cls.className" ng-model-options="{debounce:300}"
                 class="form-control app-textbox conditional-classname" [ngClass]="{'error': cls.error?.class}"
                 placeholder="{{locale.LABEL_CLASS_NAME}}"
                 (change)="liveWidgetSettingsService.validateAndUpdateNgClasses(cls);" data-identifier="property-classname"/>
          <input type="text" [(ngModel)]="cls.condition" ng-model-options="{debounce:300}" [ngClass]="{'error': cls.error?.condition}"
                 class="form-control app-textbox conditional-expression"
                 placeholder="{{locale.PLACEHOLDER_DESIGNER_CONDITION_EXPRESSION}}"
                 (change)="liveWidgetSettingsService.validateAndUpdateNgClasses(cls);" data-identifier="property-classexpression"/>
          <button type="button" title="{{locale.LABEL_WIDGET_DESIGNER_REMOVE_CONDITION}}"
                  class="btn btn-secondary conditional-class-remove-btn"
                  (click)="liveWidgetSettingsService.removeConditionalClass('field',cls)">
            <i class="wm-icon wms wms-delete"></i>
          </button>
          <button type="button" title="{{locale.LABEL_WIDGET_DESIGNER_ADD_CONDITIONAL_CLASS}}"
                  class="btn btn-secondary conditional-class-add-btn" *ngIf="isLast"
                   (click)="liveWidgetSettingsService.addConditionalClass(cls, liveWidgetSettingsService.selectedComponent.field)">
            <i class="wm-icon wms wms-plus"></i>
          </button>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.HELP_MESSAGE_WIDGET_DESIGNER_COLUMN_CONDITIONAL_CLASS}}"
             class="wms wms-help" *ngIf="isFirst"></i>
          <p class="row help-block error" *ngIf="cls.errorMsg">{{cls.errorMsg}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
